import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../constants'

export const FloatingBar = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  /* 재고 소진 딤 오버레이(z-index 100) 위에 CTA 바가 노출되도록 */
  z-index: 110;
  display: flex;
  padding: 20px 20px calc(20px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`

export const FloatingButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'soldOut',
})<{ soldOut?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 22px 0;
  border: none;
  border-radius: 12px;
  background-color: ${LANDING_COLORS.brand};
  color: ${COLORS.textInverse};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.27px;
  cursor: pointer;

  &[aria-busy='true'] {
    cursor: default;
  }

  /* 재고 소진 — 회색 비활성 디자인 (Figma 257-2590) */
  ${({ soldOut }) =>
    soldOut &&
    css`
      background-color: #e4e5e7;
      color: #acaeb4;
      cursor: default;
    `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
